import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, NgForm } from '@angular/forms';
import { typeContrat } from '../class/unit.enum';
import { AlertService } from '../services/alert-service.service';
import { AuthenticationService } from '../services/authentication.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormChangeService } from '../services/form-change.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AccessService } from '../services/access.service';
import { DigiCodService } from '../services/digicod.service';
import { EquipmentService } from '../services/equipement.service';
import { SatDatepickerRangeValue } from 'saturn-datepicker';
import { RangesFooter } from '../prospects/form-min-prospect/ranges-footer/ranges-footer.component';
import { ModalRASComponent } from '../modal/modalRAS.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-access-generation',
  templateUrl: './access-generation.component.html',
  styleUrls: ['./access-generation.component.scss']
})
export class AccessGenerationComponent implements OnInit {
  accessCreateForm: FormGroup;
  selectedCivilite: string = null;
  employeeToSave: any;
  emailInvalid: boolean;
  numSsInvalid: boolean;
  valeurAcorriger = [];
  cpInvalid: boolean;
  lstSites = [];
  lstCustomers =  [];
  typeContratEnum = typeContrat;
  keys = Object.keys;
  startingDate = new Date();

  constructor(
    private equipmentService: EquipmentService,
    private digicodService: DigiCodService,
    private accessService: AccessService,
    private fb: FormBuilder,
    protected alertService: AlertService,
    private authenSer: AuthenticationService,
    public activeModal: NgbActiveModal,
    private formService: FormChangeService,
    private modalService: NgbModal,
    private route: Router
  ) {}
  rangesFooter = RangesFooter;
  dateRange: SatDatepickerRangeValue<Date>;

  // modeAvence = false;
  accessKey: string;
  emAccessKey: string;
  degicods = new Array();
  equipments = new Array();
  selectedDegicods = [];
  selectedEquipments = [];
  datepickerStart;
  datepickerEnd;
  minDateValue = new Date();
  displayModal= 'none';
  accessKeypersonalise;
  ngOnInit() {

    this.digicodService.getDigicodFromBack().subscribe(
      data => {
      this.degicods = data;
    },
    error => {
      let msg
      if(error.error.message){
        msg = error.error.message;
      }else if(error.message){
        msg =error.message;
      }else{
        console.log("erreur :");
        console.log(JSON.parse(error));
        msg = "erreur Non parsable, ouvez la console";
      }
      this.alertService.error(msg);

    });
    this.equipmentService.getEquipmentsFromBack().subscribe(
      data => {
      this.equipments = data;
    },
    error => {
      let msg
      if(error.error.message){
        msg = error.error.message;
      }else if(error.message){
        msg =error.message;
      }else{
        console.log("erreur :");
        console.log(JSON.parse(error));
        msg = "erreur Non parsable, ouvez la console";
      }
      this.alertService.error(msg);

    });
    this.initForm();
  }
  switchChange() {
    let modeValue=  this.accessCreateForm.get(["mode"]).value;

    if("MULTI_ACCESS" === modeValue){
      let text = " le mode avancer permet de sélectionner plusieurs équipements pour un code saisi sur un digicode.\n"
      +" L’ouverture se fera donc sur toutes les portes sélectionnées";
      this.displayModal= 'block';
      const modalRef = this.modalService.open(ModalRASComponent, {
        backdrop: 'static', keyboard: false });
    modalRef.componentInstance.title = "Mode avancé";
    modalRef.componentInstance.message = text;
    modalRef.componentInstance.withCancel = true;
    modalRef.result.then(result => {
      if (result == true) {
        this.accessCreateForm.get(["mode"]).setValue('MULTI_ACCESS');
      } else {
        this.accessCreateForm.get(["mode"]).setValue('ONE_ACCESS');
      }
    });
    }
  }
  validate(form: NgForm) {
    let val = form.value;
    let otherError = new Array<string>() ;
    let dateS;
    let dateE;
      if (val.startEffect) {
         dateS = moment(val.startEffect.getTime());
      }
      if (val.endEffect) {
        dateE = moment(val.endEffect.getTime());
      }

      if (dateE && dateS && dateS.isAfter(dateE)) {
        otherError.push('Incoherence dans les dates saisies');
      }
    if (otherError.length >0) {
      this.alertService.error("Champs requis : "+otherError.join(', '), false);
      return false;
    }
    return true;
  }
  closeModalDialog(){
    this.displayModal='none'; //set none css after close dialog
   }

  initForm() {
    this.accessCreateForm = this.fb.group({
      mode: new FormControl("ONE_ACCESS"),
      digicodeIds: new FormControl("", [Validators.required]),
      accessCode: new FormControl(""),
      endEffect: new FormControl(""),
      startEffect: new FormControl(""),
      dureeEffect: new FormControl(""),
      equipmentIds: new FormControl("", [Validators.required]),
      reference: new FormControl(""),
      uniqueUsage: new FormControl("yes"),
    });
  }
  onChangedateEffect(event){
    let dateS = this.accessCreateForm.get(["startEffect"]).value ? moment(this.accessCreateForm.get(["startEffect"]).value!.getTime()) : null;
    let dateE = this.accessCreateForm.get(["endEffect"]).value ? moment(this.accessCreateForm.get(["endEffect"]).value!.getTime()) : null;
    if(dateS && dateE){
      this.accessCreateForm.patchValue({
        dureeEffect: dateE.diff(dateS,'minutes') + 1,
      });
    }
  }

  onChangePeriodEffect(event){
    let dateS = this.accessCreateForm.get(["startEffect"]).value ? moment(this.accessCreateForm.get(["startEffect"]).value.getTime()) : null;
    let duree = this.accessCreateForm.get(["dureeEffect"]).value ? this.accessCreateForm.get(["dureeEffect"]).value : null;
    if (dateS && duree){
      this.accessCreateForm.patchValue({
        endEffect: dateS.add(duree,'minutes').toDate(),
      });

    }
  }

  save(f: NgForm){

    if(!this.validate(f)) return ;
    let  mode = this.accessCreateForm.get(["mode"])!.value;
    let selectedEquip  = this.accessCreateForm.get(["equipmentIds"])!.value;
    let selectedDegic = this.accessCreateForm.get(["digicodeIds"])!.value;
    let reference = this.accessCreateForm.get(["reference"])!.value;
    let accessCode = this.accessCreateForm.get(["accessCode"])!.value;
    let dateS = this.accessCreateForm.get(["startEffect"]).value ? moment(this.accessCreateForm.get(["startEffect"]).value.getTime()) : null;
    let dateE = this.accessCreateForm.get(["endEffect"]).value ? moment(this.accessCreateForm.get(["endEffect"]).value.getTime()) : null;
    // let duree = dateS
    this.accessService.generateAccess(mode,
      dateS != null ? dateS.format("DD/MM/YYYY HH:mm:ss") : null,
      dateE != null ? dateE.format("DD/MM/YYYY HH:mm:ss") : null,
      selectedDegic, selectedEquip,
      this.accessCreateForm.get(["uniqueUsage"]).value == 'yes'?true: false, reference, accessCode).subscribe(
        data => {
          this.accessKey = data;
          // this.alertService.success('Code accès créé : '+data,true);

          const modalRef = this.modalService.open(ModalComponent, {
            backdrop: "static",
          });
          modalRef.componentInstance.message = 'Code accès créé : ' + data;
          modalRef.result.then((result) => {
            if(result){
              this.route.navigateByUrl('/editAccess');
            }
          });

        },
        error => {

          let msg;
          if(error.error.message){
            msg = error.error.message;
          }else if(error.message){
            msg =error.message;
          }else{
            console.log("erreur :");
            console.log(JSON.parse(error));
            msg = "erreur Non parsable, ouvez la console";
          }
          this.alertService.error(msg);
        });
  }
}
